
import { webcrypto } from 'node:crypto'

export const subtle = /** @type {any} */ (webcrypto).subtle
export const getRandomValues = /** @type {any} */ (webcrypto).getRandomValues.bind(webcrypto)
